import "@babel/polyfill";
import "core-js";
import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import Routing from './Routing';
import { Provider } from '@eg/elements/Provider';

import '@eg/elements/styles/core.css';
import '@eg/elements/styles/styles.css';
import "./index.scss";

require('dom4');

ReactDOM.render(<Provider theme="ergo-one">
                  <Routing />
                </Provider>, document.getElementById('root'))
